import { render, staticRenderFns } from "./search-brand-filters.vue?vue&type=template&id=bdcf4a62"
import script from "./search-brand-filters.vue?vue&type=script&lang=js"
export * from "./search-brand-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports